baseApp.service('CloudAccessService', ['GeneralUtilsService', function(GeneralUtilsService,$rootScope) {

    let CloudAccessService = {};

    CloudAccessService.getCloudAccessSettings = function(accountId, callback) {
        fetchData(accountId, function(data) {
            callback(data);
        });
    };

    var setData = function(accountId, account, callback) {
        store.save({
            path: '/edit',
            data: account,
            dataObj: 'json',
            queryParams: {
                accountId: accountId,
                save: true,
                fields: "['cloudAccessConfiguration']",
            },
            success: function (data) {
                callback(data);
            },
        });
    }

    CloudAccessService.saveCloudAccessSettings = function(accountId, account, callback) {
        setData(accountId, account, function(data) {
            callback(data);
        });
    }

     CloudAccessService.saveAccountWithCloudConfiguration = function(accountId, cloudAccessConfiguration, successCallback, errorCallback) {
        store.save({
            path: '/edit',
            data: {id: accountId, cloudAccessConfiguration: cloudAccessConfiguration, newSaveMethod: true},
            dataObj: 'json',
            queryParams: {
                accountId: accountId,
                save: true,
                fields: "['cloudAccessConfiguration']",
            },
            success: function (data) {
                if (data.status !== 'ERROR') {

                   if(successCallback){
                        successCallback(data);
                   }
                }
                else if (errorCallback){
                    errorCallback(data);
                }
            },
        });
    }

     function fetchData(accountId, callback) {
        store.fetch({
            path: '/cloudAccessConfiguration',
            queryParams: { accountId: accountId },
            success: function (data) {
                callback({
                    cloudAccessConfiguration: data.model
                });
            }
        })
    };

    CloudAccessService.isApplicationIpRangeAvailable = function(accountId, callback) {
        isIpRangeAvailable(accountId, callback);
    }

    function isIpRangeAvailable(accountId, callback) {
        store.fetch({
            path: '/isDefaultRangeValid',
            queryParams: { accountId: accountId },
            success: function (data) {
                callback(data);
            }
        })
    };

    CloudAccessService.getServerUrl = function(callback) {
        store.fetch({
            path: '/getServerUrl',
            success: function (data) {
                callback(data);
            }
        })
    }

    CloudAccessService.isSSOLoginEnabled = function(accountId, callback) {
        store.fetch({
												path: '/isSSOLoginEnabled',
												queryParams: { accountId: accountId },
												success: function (data) {
																callback(data);
												}
								})
				}

				CloudAccessService.getSsoProvider = function(accountId, callback) {
								store.fetch({
												path: '/getSsoProvider',
												queryParams: { accountId: accountId },
												success: function (data) {
																callback(data);
												}
								})
				}

    return CloudAccessService;
}]);
